import { useTurns } from '@/contexts/TurnsProvider'
import { useEffect, useState } from 'react'

export const TimerDisplayServer = ({ duration }: { duration: number }) => {
  const { timer } = useTurns()
  const [textColor, setTextColor] = useState('text-green-500')

  const totalMs = duration * 60 * 1000
  const fractionRemaining = timer / totalMs

  useEffect(() => {
    let color = 'text-green-500'
    if (fractionRemaining <= 0.4) color = 'text-orange-500'
    if (fractionRemaining < 0.2) color = 'text-red-500'
    setTextColor(color)
  }, [fractionRemaining])

  const minutes = Math.floor(timer / 60000)
  const seconds = Math.floor((timer % 60000) / 1000)

  return (
    <div className={textColor}>
      {minutes}:{String(seconds).padStart(2, '0')}
    </div>
  )
}
